/**
 * Utility for managing dynamic meta tags for SEO
 */
export const updateMetaTags = (meta) => {
  const {
    title,
    description,
    keywords,
    ogTitle,
    ogDescription,
    ogImage,
    canonical,
    twitterTitle,
    twitterDescription,
    twitterImage
  } = meta;

  // Update document title
  if (title) {
    document.title = title;
  }

  // Update or create meta tags
  const updateMetaTag = (name, content, attribute = 'name') => {
    if (!content) return;
    
    let element = document.querySelector(`meta[${attribute}="${name}"]`);
    if (!element) {
      element = document.createElement('meta');
      element.setAttribute(attribute, name);
      document.head.appendChild(element);
    }
    element.setAttribute('content', content);
  };

  // Standard meta tags
  updateMetaTag('description', description);
  updateMetaTag('keywords', keywords);
  
  // Open Graph tags
  updateMetaTag('og:title', ogTitle || title, 'property');
  updateMetaTag('og:description', ogDescription || description, 'property');
  updateMetaTag('og:image', ogImage, 'property');
  
  // Twitter Card tags
  updateMetaTag('twitter:title', twitterTitle || title);
  updateMetaTag('twitter:description', twitterDescription || description);
  updateMetaTag('twitter:image', twitterImage);
  
  // Canonical URL
  if (canonical) {
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.setAttribute('href', canonical);
  }
};

// Default meta tags for the site
export const defaultMeta = {
  siteName: 'UK Salary Toolkit',
  siteUrl: 'https://uksalarytoolkit.com',
  defaultImage: 'https://uksalarytoolkit.com/og-image.jpg',
};

